export * from './de-en.urls';
